(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cql-credibility-ticker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // get ticker wrapper
    var parentElement = document.querySelector('.credibility-ticker-content');
    // append copies of ticker credibility claims for 'infinite scroll' effect
    if (parentElement) {
        var childElements = Array.from(parentElement.children);
        for (var i = 0; i < 10; i++) { // Repeat the entire list 10 times
            childElements.forEach(function (child) {
                var clonedChild = child.cloneNode(true);
                parentElement.appendChild(clonedChild);
                clonedChild.classList.add('cloned-item');
                clonedChild.classList.remove('original-item');
            });
        }
    }

    // listen for screen resize to start/stop ticker auto scroll
    function updateScrollActiveClass() {
        if (window.innerWidth <= 1023) {
            parentElement.classList.add('scroll-active');
        } else {
            parentElement.classList.remove('scroll-active');
        }
    }
    updateScrollActiveClass(); // Initial check
    window.addEventListener('resize', updateScrollActiveClass); // Listen for resize events

    // toggle mobile ticker play/pause buttons
    document.getElementById('ticker-button').addEventListener('click', function () {
      const playSpan = document.getElementById('play-ticker');
      const pauseSpan = document.getElementById('pause-ticker');
      if (playSpan.style.display === 'none') {
          playSpan.style.display = 'flex';
          pauseSpan.style.display = 'none';
      } else {
          playSpan.style.display = 'none';
          pauseSpan.style.display = 'flex';
      }
      parentElement.classList.toggle('paused');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (document.querySelector('build-kit') || document.querySelector('custom-kit')) {
        return;
      }
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-stack"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.card-content').forEach((cardContent) => {
      const ctaElements = Array.from(cardContent.querySelectorAll('[id*="__cta_"]'));
      if (ctaElements.length > 1) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('multiple-cta-wrapper');
        ctaElements.forEach((ctaElement) => {
          newDiv.appendChild(ctaElement);
        });
        cardContent.appendChild(newDiv);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styleguide"] && !Shopify.designMode) return;
  try {
    
                document.addEventListener("DOMContentLoaded", function (e) {
                    const dropdown = document.getElementById("custom-dropdown");
                    const fieldLabel = document.getElementById("field-label");
                    const dropdownMenu = dropdown.nextElementSibling;
                    const dropdownItems = dropdownMenu.querySelectorAll(".dropdown-item");
                    const dropdownArrow = document.getElementById("dropdown-arrow");

                    function toggleDropdown() {
                        if (dropdown.classList.contains("disabled")) return;
                        const element = event.target;
                        const rect = element.getBoundingClientRect();
                        const distanceFromBottom = window.innerHeight - rect.bottom;
                        dropdownArrow.classList.add("flip");

                        // If space below is less than 200px, open dropdown upwards
                        if (distanceFromBottom < 200) {
                            dropdownMenu.classList.remove("drop-down");
                            dropdownMenu.classList.add("drop-up");
                        } else {
                            dropdownMenu.classList.remove("drop-up");
                            dropdownMenu.classList.add("drop-down");
                        }
                        const expanded = dropdown.getAttribute("aria-expanded") === "true";
                        dropdown.setAttribute("aria-expanded", !expanded);
                        dropdownMenu.classList.toggle("open");
                    }
                    document.addEventListener("click", function (event) {
                        if (event.target.classList.contains("custom-dropdown")) {
                            toggleDropdown(event.target);
                        }
                    });

                    dropdownItems.forEach(item => {
                        item.addEventListener("click", function () {
                            dropdown.querySelector("span:first-child").textContent = this.textContent;
                            dropdown.classList.add("selected");
                            fieldLabel.classList.add("selected")
                            dropdown.setAttribute("aria-expanded", "false");
                            dropdownMenu.classList.remove("open");
                            dropdownArrow.classList.remove("flip");
                        });
                    });

                    document.addEventListener("click", function (e) {
                        if (!dropdown.contains(e.target) && !dropdownMenu.contains(e.target) || (dropdown.contains(e.target) && dropdown.getAttribute("aria-expanded") === "false")) {
                            dropdown.setAttribute("aria-expanded", "false");
                            dropdownMenu.classList.remove("open");
                            dropdownArrow.classList.remove("flip");
                        }
                    });

                    dropdown.addEventListener("keydown", function (e) {
                        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                            e.preventDefault();
                            const items = Array.from(dropdownItems);
                            const currentIndex = items.findIndex(item => item.classList.contains("selected"));
                            let nextIndex = e.key === "ArrowDown" ? currentIndex + 1 : currentIndex - 1;
                            if (nextIndex < 0) nextIndex = items.length - 1;
                            if (nextIndex >= items.length) nextIndex = 0;
                            items.forEach(item => item.classList.remove("selected"));
                            items[nextIndex].classList.add("selected");
                            dropdown.querySelector("span:first-child").textContent = items[nextIndex].textContent;
                        }
                    });

                    function setError(state) {
                        if (state) {
                            dropdown.classList.add("error");
                            document.querySelector(".helper-text").style.display = "block";
                        } else {
                            dropdown.classList.remove("error");
                            document.querySelector(".helper-text").style.display = "none";
                        }
                    }

                    function setDisabled(state) {
                        if (state) {
                            dropdown.classList.add("disabled");
                            dropdown.setAttribute("aria-disabled", "true");
                        } else {
                            dropdown.classList.remove("disabled");
                            dropdown.setAttribute("aria-disabled", "false");
                        }
                    }
        });
    
        
  } catch(e) { console.error(e); }
})();
})();
